import React from 'react'
import styled from 'react-emotion'
import throttle from 'lodash/throttle'
import Link from 'gatsby-link';

import { UnstyledLink } from '../utils/styles'
import { ReactComponent as BackIcon } from '../svg/arrow-left.svg'
import { ReactComponent as CloseIcon } from '../svg/close.svg'
import { ReactComponent as MenuIcon } from '../svg/menu.svg'

const NavButton = styled('button')(() => ({
  backgroundColor: 'transparent',
  border: 0,
  boxSizing: 'content-box',
  height: '1em',
  padding: '1em',
  width: '1em',

  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, .1)',
  },

  svg: {
    verticalAlign: 'top',
  }
}))

class Header extends React.Component {
  state = {
    visible: typeof window !== `undefined` && window.scrollY < 70,
    scroll: typeof window !== `undefined` ? window.scrollY : 0,
    atTop: typeof window !== `undefined` && window.scrollY === 0,
  }

  handleScroll = () => {
    if (typeof window === `undefined`) return
    this.setState((prevState, props) => ({
      visible: prevState.scroll > window.scrollY || window.scrollY < 70,
      scroll: window.scrollY,
      atTop: window.scrollY < 10,
    }))
  }

  componentDidMount() {
    if (typeof window === `undefined`) return
    window.addEventListener('scroll', throttle(this.handleScroll, 100))
  }

  render() {
    const { isHomepage, workSingle, menuToggle, isOpen, goBack } = this.props
    return (
      <header
        css={{
          backgroundColor: '#fff',
          boxShadow: this.state.visible && !this.state.atTop ? '0 0px 4px rgba(0, 0, 0, .1), 0 3px 8px rgba(0, 0, 0, .1)' : '',
          display: 'flex',
          justifyContent: 'space-between',
          left: 0,
          position: this.state.atTop ? 'absolute' : 'fixed',
          top: 0,
          transform: this.state.visible ? 'translateY(0)' : 'translateY(-100%)',
          transition: 'transform .3s ease',
          width: '100%',
          zIndex: 10,
        }}
      >
        <nav
          css={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            margin: '0 auto',
            maxWidth: 800,
            padding: 10,
            width: '100%',
          }}
        >
          <div>
            {workSingle &&
            <NavButton onClick={() => goBack()}>
              <BackIcon />
            </NavButton>}
            {!workSingle && !isHomepage && <Link
              to="/"
              className={UnstyledLink}
              css={{
                fontFamily: 'Raleway',
                textTransform: 'uppercase',
              }}
            >
              Patrícia Marques
            </Link>}
          </div>
          <div>
            <NavButton onClick={() => menuToggle()}>
              {!isOpen && <MenuIcon />}
              {isOpen && <CloseIcon />}
            </NavButton>
          </div>
        </nav>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js